module.exports = __webpack_public_path__ + "img/move_down.6784e6be.png";